module.exports = __webpack_public_path__ + "static/media/note2.1aafd4a4.png";